import React from 'react';
import { Users, TrendingUp, Bot, Send } from 'lucide-react';
import { StatCard } from './shared';

export function DashboardTab({ dashboard }) {
  if (!dashboard) {
    return <div className="text-center py-10 text-gray-400">Carregando...</div>;
  }

  return (
    <div className="space-y-6">
      {/* Cards de Estatísticas */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard
          title="Total de Leads"
          value={dashboard.total_leads}
          icon={Users}
          color="blue"
        />
        <StatCard
          title="Taxa de Conversão"
          value={`${dashboard.conversion_rate}%`}
          icon={TrendingUp}
          color="green"
        />
        <StatCard
          title="Bots Detectados"
          value={`${dashboard.bot_detection_rate}%`}
          icon={Bot}
          color="orange"
        />
        <StatCard
          title="Campanhas Ativas"
          value={dashboard.active_campaigns}
          icon={Send}
          color="purple"
        />
      </div>

      {/* Leads por Status */}
      <div className="bg-gray-800/50 rounded-xl p-6 border border-gray-700/50">
        <h3 className="text-lg font-semibold text-white mb-4">Leads por Status</h3>
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-4">
          {[
            { key: 'new', label: 'Novos', color: 'gray' },
            { key: 'contacted', label: 'Contatados', color: 'blue' },
            { key: 'qualified', label: 'Qualificados', color: 'yellow' },
            { key: 'interested', label: 'Interessados', color: 'purple' },
            { key: 'converted', label: 'Convertidos', color: 'green' },
            { key: 'rejected', label: 'Rejeitados', color: 'red' },
            { key: 'bot_detected', label: 'Bots', color: 'orange' }
          ].map(({ key, label, color }) => (
            <div key={key} className="text-center">
              <p className={`text-2xl font-bold text-${color}-400`}>
                {dashboard.leads_by_status[key] || 0}
              </p>
              <p className="text-gray-400 text-sm">{label}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Leads por Segmento */}
      {dashboard.leads_by_segment?.length > 0 && (
        <div className="bg-gray-800/50 rounded-xl p-6 border border-gray-700/50">
          <h3 className="text-lg font-semibold text-white mb-4">Leads por Segmento</h3>
          <div className="space-y-3">
            {dashboard.leads_by_segment.map((seg, idx) => (
              <div key={idx} className="flex items-center justify-between">
                <span className="text-gray-300">{seg._id || 'Sem segmento'}</span>
                <span className="text-blue-400 font-semibold">{seg.count}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

